export default __webpack_public_path__ + "static/media/SensorThighRight.435b339b.svg";